export default "__VITE_ASSET__5b3hAC$A__"